export const gameStates = [
    { title: 'games_list.games_list_4', state: 'scheduled', state_ids: [1, 10, 13, 16, 19, 26] },
    { title: 'games_list.games_list_1', state: 'live', state_ids: [2, 3, 4, 6, 9, 18, 21, 22, 23, 25] },
    { title: 'games_list.games_list_5', state: 'finished', state_ids: [5, 7, 8, 11, 12, 14, 15, 17, 20] }
]

export function getStateTitle(state: number): string {
    return gameStates.find((gs) => gs.state_ids.includes(state))?.title || '';
}